import { useEffect } from 'react';

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1', '[::1]']);

// Fallback for pages rendered outside AuthProvider (e.g. /login), where the
// authenticated /me response is unavailable. Mirrors the environment-chooser
// hostnames in MainLayout.
const HOSTNAME_PROJECT_IDS: Record<string, string> = {
  'trecs-brain-1049481196174.europe-central2.run.app': 'trecs-aero-prod',
  'brain.sandbox.trecs.dev': 'trecs-aero-sandbox',
  'trecs-brain-332913505761.europe-central2.run.app': 'trecs-aero-dev',
  'brain.dev.trecs.dev': 'trecs-aero-dev',
  'brain.predev.trecs.dev': 'trecs-aero-predev',
};

function isLocalhost() {
  return LOCAL_HOSTNAMES.has(window.location.hostname);
}

function faviconForEnvironment(projectId: string | null | undefined) {
  if (isLocalhost()) {
    return '/favicon-local.svg';
  }

  const resolvedProjectId = projectId ?? HOSTNAME_PROJECT_IDS[window.location.hostname];
  if (!resolvedProjectId) {
    return null;
  }

  if (/predev/i.test(resolvedProjectId)) {
    return '/favicon-predev.svg';
  }

  if (/prod/i.test(resolvedProjectId)) {
    return '/favicon-prod.svg';
  }

  if (/sandbox/i.test(resolvedProjectId)) {
    return '/favicon-sandbox.svg';
  }

  return null;
}

export function useEnvironmentFavicon(projectId?: string | null) {
  useEffect(() => {
    const href = faviconForEnvironment(projectId);
    if (!href) {
      return;
    }

    document
      .querySelectorAll<HTMLLinkElement>('link[rel="icon"], link[rel="shortcut icon"]')
      .forEach((link) => {
        link.href = href;
        link.type = 'image/svg+xml';
      });
  }, [projectId]);
}
